
/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';
import type {
  ProfileTranslation,
} from '../models';
import {
    ProfileTranslationFromJSON,
    ProfileTranslationToJSON,
} from '../models';

export interface GetProfileTranslationRequest {
    profileId: string;
    language: string;
}

/**
 * 
 */
export class ProfileTranslationApi extends runtime.BaseAPI {

    /**
     * Gets profile translation
          */
    async getProfileTranslationRaw(requestParameters: GetProfileTranslationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<ProfileTranslation>> {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError(
                'profileId',
                'Required parameter "profileId" was null or undefined when calling getProfileTranslation().'
            );
        }

        if (requestParameters['language'] == null) {
            throw new runtime.RequiredError(
                'language',
                'Required parameter "language" was null or undefined when calling getProfileTranslation().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['language'] != null) {
            queryParameters['language'] = requestParameters['language'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<ProfileTranslation>({
            path: `/profile/public-api/profiles/{profileId}/translations`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=ProfileTranslationFromJSON(response._data); }
        return response;
    }

    /**
     * Gets profile translation
          */
    async getProfileTranslation(requestParameters: GetProfileTranslationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<ProfileTranslation> {
        const response = await this.getProfileTranslationRaw(requestParameters, initOverrides);
        return response._data;
    }

}
